import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
const locales = {
    en: import('dayjs/locale/en'),
    fr: import('dayjs/locale/fr'),
};
export default class DayJsUtil {
    static dayjs(dateTime, dateTimeFormat) {
        dayjs.extend(customParseFormat);
        let dayjsValue = dateTime ? dayjs(dateTime) : dayjs();
        dayjsValue = dateTime && dateTimeFormat ? dayjs(dateTime, dateTimeFormat) : dayjsValue;
        return dayjsValue;
    }
    static format({ date, time, dateFormat, timeFormat, outPutFormat }) {
        dayjs.extend(customParseFormat);
        if (date && time && dateFormat && timeFormat) {
            return dayjs(`${date} ${time}`, `${dateFormat} ${timeFormat}`).format(outPutFormat);
        }
        else if (date && dateFormat) {
            return dayjs(`${date}`, `${dateFormat}`).format(outPutFormat);
        }
        else if (time && timeFormat) {
            return dayjs(`${time}`, `${timeFormat}`).format(outPutFormat);
        }
        else if (date && time) {
            return dayjs(`${date} ${time}`).format(outPutFormat);
        }
        else if (date) {
            return dayjs(`${date}`).format(outPutFormat);
        }
        else {
            return dayjs().format(outPutFormat);
        }
    }
    static formatValue(dateTime, outputFormat) {
        return dateTime.format(outputFormat);
    }
    static getUnix(dateTime = '', inUtc = false) {
        const dateObj = dateTime ? dayjs.unix(dateTime) : dayjs();
        if (inUtc) {
            dayjs.extend(utc);
            return dateObj.utc();
        }
        return dateObj;
    }
    /**
     * Convert the given timeStr to dayJs object
     * @param timeStr {Record<string, number|string>}
     * @param timeFormat {Record<string, number|string>}
     * @returns {dayjs.Dayjs|*}
     */
    static strToTime(timeStr, timeFormat = 'HH:mm') {
        if (timeStr?.length === 4 || timeFormat?.length > 0) {
            return dayjs(timeStr, timeFormat);
        }
    }
    /**
     * addTimeSeparator - takes in a time as HHmm and converts it to HH:mm
     * @param timeString - time in HHmm format
     * @returns {string} - time in HH:mm format
     */
    static addTimeSeparator(timeString) {
        if (timeString?.length === 4) {
            return dayjs(timeString, 'HHmm').format('HH:mm');
        }
    }
    static setUnix(dateTime) {
        return dateTime.unix();
    }
    static nowInEpoch() {
        return dayjs().unix();
    }
    static valueOf(dateTime) {
        return dateTime.valueOf();
    }
    static isBetween(value, start, end) {
        dayjs.extend(isBetween);
        return value.isBetween(start, end);
    }
    static isBetweenInclusive(dateStr, startStr, endStar) {
        dayjs.extend(isBetween);
        return dayjs(dateStr).isBetween(startStr, endStar, null, '[]');
    }
    static tz(dateTime, currentTimeZone = null) {
        dayjs.extend(utc);
        dayjs.extend(timezone);
        if (currentTimeZone === '' || currentTimeZone === null)
            return dayjs.tz(dateTime, dayjs.tz.guess()).local();
        else
            return dayjs.tz(dateTime, currentTimeZone);
    }
    static isSame(value, compareWith) {
        return value.isSame(compareWith);
    }
    static isAfter(value, startTime) {
        return value.isAfter(startTime);
    }
    static isBefore(value, endTime) {
        return value.isBefore(endTime);
    }
    static add(value, time, units) {
        return value.add(time, units);
    }
    static subtract(value, time, units) {
        return value.subtract(time, units);
    }
    static day(value) {
        return value.day();
    }
    static isSameOrBefore(value, compareWith, unit) {
        dayjs.extend(isSameOrBefore);
        return value.isSameOrBefore(compareWith, unit);
    }
    static isValidDate(date, dateFormat, isStrict) {
        return dayjs(`${date}`, `${dateFormat}`, isStrict).isValid();
    }
    static setDayJsLocale(language) {
        const data = Object.keys(locales).find((key) => key === language) || 'en';
        return dayjs.locale(data);
    }
}
